<template>
    <div class="py-4 container-fluid">
        <div class="custom-header font-weight-bold text-left">Guest List</div>

        <div class="card mb-4">
            <div class="card-header">
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col">
                                <div class="row">
                                    <div class="col-md-8 text-left" style="padding-right: 150px;">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <button class="btn btn-sm tnkc-secondary dropdown-toggle border-0"
                                                        type="button"
                                                        data-toggle="dropdown"
                                                        aria-haspopup="true"
                                                        aria-expanded="false">
                                                    <i class="fa fa-search pr-2"></i>By : {{key}}
                                                </button>

                                                <div class="dropdown-menu">
                                                    <a class="dropdown-item" href="#" @click="setKey('all')" :class="{'active':guestParams.searchKey == 'all'}">All</a>
                                                    <a class="dropdown-item" href="#" @click="setKey('last_name')" :class="{'active':guestParams.searchKey == 'last_name'}">LastName</a>
                                                    <a class="dropdown-item" href="#" @click="setKey('first_name')" :class="{'active':guestParams.searchKey == 'first_name'}">FirstName</a>
                                                    <a class="dropdown-item" href="#" @click="setKey('middle_name')" :class="{'active':guestParams.searchKey == 'middle_name'}">MiddleName</a>
                                                </div>
                                            </div>

                                            <input type="text"
                                                   id="guestValue"
                                                   class="form-control form-control"
                                                   v-model="guestParams.searchValue"
                                                   v-on:input="searchGuest(1)"
                                                   :placeholder="keyPlaceHolder"
                                                   aria-label="Text input with dropdown button">
                                        </div>
                                    </div>

                                  <button type="button" class="btn btn-sm tnkc-success px-5" data-toggle="modal" data-target="#addGuest">
                                    <font-awesome-icon icon="plus"/>
                                    Add Guest
                                  </button>
                                </div>
                            </div>

                            <div class="col col-lg-4">
                                <select class="custom-select custom-select-sm w-50" id="displayCounts" v-model="guestParams.count" v-on:change="setRecords">
                                    <option v-for="count in displayCounts" :key="count" :value="count" :selected="count === guestParams.count">
                                        {{count}} records
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body fs-13px">
                <div class="text-left">
                    <small> {{`${guestListPagination.from} - ${guestListPagination.to} of ${guestListPagination.total}`}}</small>
                </div>

                <nav aria-label="..." class="pt-0">
                    <ul class="pagination pagination-sm">
                        <li class="page-item" :class="{ 'disabled': guestListPagination.currentPage === 1}">
                            <button class="page-link" @click="setPage(1)">
                                <font-awesome-icon icon="step-backward"/>
                                First
                            </button>
                        </li>

                        <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === guestListPagination.currentPage }">
                            <button class="page-link" @click="setPage(page)">{{ page }}</button>
                        </li>

                        <li class="page-item" :class="{ 'disabled': guestListPagination.currentPage === guestListPagination.lastPage}">
                            <button class="page-link" @click="setPage(guestListPagination.lastPage)">
                                Last
                                <font-awesome-icon icon="step-forward"/>
                            </button>
                        </li>
                    </ul>
                </nav>

                <div class="table-responsive-lg">
                    <table class="table table-bordered" width="100%" cellspacing="0">
                            <thead>
                                <tr class="bg-light">
                                    <th scope="col" class="p-1 text-center">
                                        <button class="btn btn-sm tnkc-secondary" v-on:click="searchGuest" data-toggle="tooltip" data-placement="top" data-html="true" title="Click to Refresh Data Table">
                                            <font-awesome-icon icon="undo"/>
                                        </button>
                                    </th>
                                </tr>
                                <tr class="bg-light">
                                    <th scope="col" class="p-1">#</th>
                                    <th scope="col" class="p-1">Guest Name</th>
                                    <th scope="col" class="p-1">Company Name</th>
                                    <th scope="col" class="p-1">Address</th>
                                    <th scope="col" class="p-1">Email</th>
                                    <th scope="col" class="p-1">Contact Number</th>
                                    <th scope="col" class="p-1 ">Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(guest,index) in guests" :key="guest.guestId">
                                    <td scope="row" class="p-1" width="10">{{parseInt(index) + 1}}</td>
                                    <td class="p-1 text-left">{{guest.guestName}}</td>
                                    <td class="p-1">{{guest.companyName ? guest.companyName : '----'}}</td>
                                    <td width="25%" class="text-wrap p-1">{{guest.address}}</td>
                                    <td class="p-1" width="15%">{{guest.email}}</td>
                                    <td class="p-1" width="10%">{{guest.contactNumber ? guest.contactNumber : '---'}}</td>
                                    <td class="p-1 vert-aligned">
                                        <button class="btn btn-xsm tnkc-primary" @click="view_guest(guest.guestId)">
                                            <font-awesome-icon icon="eye"/>
                                            <span class="ml-1 small">View</span>
                                        </button>

                                      <button v-show="!guest.hasActiveBooking" class="btn btn-xsm tnkc-success ml-1"
                                                data-toggle="modal"
                                                data-target="#guestBookedModal"
                                                data-backdrop="static"
                                                data-keyboard="false"
                                                v-on:click="set_init_guest(guest)">
                                            <font-awesome-icon icon="bookmark"/>
                                            <span class="ml-1 small">Book</span>
                                        </button>

                                        <button class="btn btn-xsm tnkc-danger ml-1" @click="delete_guest(guest.guestId)">
                                            <font-awesome-icon icon="trash"/>
                                            <span class="ml-1 small">Delete</span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                    </table>
                </div>
            </div>

        </div>

        <!-- New Guest -->
        <div class="modal fade" id="addGuest" tabindex="-1" role="dialog" aria-labelledby="addGuestModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="addGuestModalTitle">Add Guest</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group text-left">
                                    <label class="font-weight-bold" for="firstname">First Name:</label>
                                    <input type="text" id="firstname" class="form-control form-control-sm" placeholder="First Name" required v-model="newGuest.firstName">
                                </div>

                                <div class="form-group text-left">
                                    <label class="font-weight-bold" for="middlename">Middle Name:</label>
                                    <input type="text" id="middlename" class="form-control form-control-sm" placeholder="Middle Name" required v-model="newGuest.middleName">
                                </div>

                                <div class="form-group text-left">
                                    <label class="font-weight-bold" for="middlename">Last Name:</label>
                                    <input type="text" id="lastname" class="form-control form-control-sm" placeholder="Last Name" required v-model="newGuest.lastName">
                                </div>

                                <div class="form-group text-left">
                                    <label class="font-weight-bold" for="suffix">Suffix Name:</label>
                                    <input type="text" id="suffix" class="form-control form-control-sm" placeholder="Suffix Name" required v-model="newGuest.suffixName">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group text-left">
                                    <label class="font-weight-bold" for="company">Company:</label>
                                    <input type="text" id="company" class="form-control form-control-sm" placeholder="Company" required v-model="newGuest.company">
                                </div>

                                <div class="form-group text-left">
                                    <label class="font-weight-bold" for="con_number">Contact Number:</label>
                                    <input type="number" id="con_number" min="11" max="11" class="form-control form-control-sm" placeholder="Ex. 09092001112" required v-model="newGuest.contactNumber">
                                </div>


                                <div class="form-group text-left">
                                    <label class="font-weight-bold" for="email">Email:</label>
                                    <input type="email" id="email" class="form-control form-control-sm" placeholder="Email" required v-model="newGuest.email">
                                </div>

                                <div class="form-group text-left">
                                    <label class="font-weight-bold" for="address">Address:</label>
                                    <input type="text" id="address" class="form-control form-control-sm" placeholder="Address" required v-model="newGuest.address">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm tnkc-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-sm tnkc-primary" v-on:click="create_guest">Save changes</button>
                    </div>
                </div>
            </div>
        </div>


        <!-- guest booking   -->
        <guest-booking-modal
                :initGuest="initGuest"
                :setNull="set_init_guest_null"
        />

    </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import {appMixins} from '../../mixins/app.mixins';
  import GuestBookingModal from './_modals/guestBookingModal';

  export default {
    name: 'GuestList',
    mixins: [appMixins],
    components: {
      GuestBookingModal: GuestBookingModal,
    },
    data() {
      return {
        //todo
        key: '',
        keyPlaceHolder: '',

        displayCounts: [5, 10, 15, 20, 30, 50, 100, 200],
        initGuest : {},
      };
    },

    methods: {
      ...mapActions([
        'getGuestList',
        'createGuest',
        'getGuestList',
        'viewGuestDetails',
        'updateGuest',
        'deleteGuest',
        'setParamsNull',
        'bedsPerRoomGuest'
      ]),

      //page
      setPage(page) {
        this.guestListPagination.currentPage = page;
        this.searchGuest();
      },

      setRecords(e) {
        this.guestParams.count = parseInt(e.target.value, 10);
        this.searchGuest(1);
      },

      searchGuest(initializePage = null) {
        let page = (initializePage) ? initializePage : this.guestListPagination.currentPage;
        this.guestParams.page = page;
        this.getGuestList(this.guestParams);
      },

      setKey(obj) {
        this.guestParams.searchKey = obj;
        this.searchBy();
      },

      searchBy() {
        switch (this.guestParams.searchKey) {
          case 'all':
            this.key = 'All';
            this.keyPlaceHolder = 'Search here ...';
            break;

          case 'last_name':
            this.key = 'LastName';
            this.keyPlaceHolder = 'Search Last Name here ...';
            break;

          case 'first_name':
            this.key = 'FirstName';
            this.keyPlaceHolder = 'Search First Name here ...';
            break;

          case 'middle_name':
            this.key = 'MiddleName';
            this.keyPlaceHolder = 'Search Middle Name here ...';
            break;

        }
      },

      async create_guest() {
        if (await this.questionAlert('Are you sure you want to add this record.?')) {
          this.newGuest.contactNumber = parseInt(this.newGuest.contactNumber, 10);
          this.createGuest(this.newGuest).then((res) => {
            if (res == true) {
              this.successAlert('Guest successfully save.');
            }
          });
        }
      },

      view_guest(id) {
        this.$router.push({name: 'GuestProfile', params: {guest_id: id}});
      },

      update_guest() {
      },

      async delete_guest(guestID) {
        if (await this.questionAlert('Are you sure to delete this guest?', 'DELETE')) {
          this.deleteGuest(guestID).then((response) => {
            if (response === true) {
              this.successAlert('Guest Deleted Successfully', 'DELETE');
              this.searchGuest();
            }
          });
        }
      },

      //todo save guestBooked
      set_init_guest(guest){
        this.bedsPerRoomGuest({hotel_id : 1});
        this.initGuest = guest;
      },

      set_init_guest_null(){
        this.initGuest = {};
      },
    },

    computed: {
      ...mapGetters(['guest', 'guests', 'newGuest',
        'guestListPagination', 'guestParams']),

      paginationPages() {
        let pages = [];
        let currentPage = this.guestListPagination.currentPage;
        let lastPage = this.guestListPagination.lastPage;
        if (lastPage > 1) {
          let initialLimit = 1;
          if (currentPage + 5 > lastPage) {
            initialLimit = lastPage - 10;
          } else if (currentPage > 6) {
            initialLimit = currentPage - 5;
          }
          initialLimit = initialLimit < 1 ? 1 : initialLimit;
          for (let i = initialLimit; i <= initialLimit + 10; i++) {
            pages.push(i);
            if (i >= lastPage) {
              break;
            }
          }
        }
        return pages;
      },
    },

    created() {
      this.searchGuest();
      this.searchBy();
    },

    mounted() {
      $(function() {
        $('[data-toggle="tooltip"]').tooltip({
          trigger: 'hover',
        });
      });
    },

    destroyed() {
      this.set_init_guest_null();
    },

    /*watch:{

    }*/

  };
</script>

<style scoped>
    .btn-xsm, .btn-group-xsm > .btn {
        padding: 0.20rem 0.2rem !important;
        font-size: 0.870rem !important;
        line-height: 1 !important;
        border-radius: 0.25rem !important;
    }


    .table tbody > tr > td.vert-aligned {
        vertical-align: middle;
        padding: 0!important;
    }


    .fs-13px {
        font-size: 13px;
    }

</style>
